import { Buffer } from 'buffer'
;(window as unknown as { Buffer: typeof Buffer }).Buffer = Buffer

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import { initSentry } from './lib/sentry'
import { queryClient } from './lib/queryClient'
import { AuthProvider } from './contexts/AuthContext'
import { SolanaWalletProvider } from './contexts/SolanaWalletContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { Toaster } from './components/ui/toaster'
import App from './App'
import './index.css'

// Initialize Sentry before rendering
initSentry()

function FallbackComponent() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', color: 'hsl(var(--foreground))', background: 'hsl(var(--background))', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Something went wrong</h1>
      <p style={{ color: 'hsl(var(--muted-foreground))', marginBottom: '1.5rem' }}>An unexpected error occurred. Please refresh the page.</p>
      <button
        onClick={() => window.location.reload()}
        style={{ padding: '0.5rem 1.5rem', background: '#CCFF00', color: '#000', border: 'none', borderRadius: '0.375rem', cursor: 'pointer', fontWeight: 600 }}
      >
        Refresh
      </button>
    </div>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={FallbackComponent}>
      <BrowserRouter>
        <ThemeProvider>
          <SolanaWalletProvider>
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <App />
                <Toaster />
              </AuthProvider>
            </QueryClientProvider>
          </SolanaWalletProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>
)
